import * as React from 'react'
import * as ReactModal from 'react-modal'

// XXX: hack, somehow react modal imported in storybook is exported as default
const ReactModalComponent = (ReactModal as any).default
  ? (ReactModal as any).default
  : ReactModal

export interface Props {
  onClose?: () => void
}

export default class InfoModal extends React.Component<Props> {
  render () {
    return (
      <ReactModalComponent
        isOpen
        contentLabel='Information Modal'
        onRequestClose={this.props.onClose}
        style={{
          content: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            right: 'initial',
            bottom: 'initial',
            transform: 'translate(-50%, -50%)',
            padding: '1.8rem'
          }
        }}>
        <div style={{ fontFamily: 'Roboto, sans-serif' }}>
          <img
            className='left mr1'
            src='/images/icon@2x.png'
            style={{ width: '32px', height: '32px' }}
          />
          <h2 className='my0'>TipWander</h2>
          <p>
            Wonder what's new around? Welcome to the wanderland! TipWander is a
            platform that allows you to explore the world with your finger tip.
          </p>
          <p>
            Any feedback? Feel free to contact us at{' '}
            <i className='fa fa-envelope' />{' '}
            <a href='mailto:hello@tipwander.com'>hello@tipwander.com</a>
          </p>
          <p>
            Fllow our Twitter at{' '}
            <a href='https://twitter.com/tipwander' target='_blank'>
              @tipwander
            </a>
          </p>
          <div>
            <a href='https://tipwander.com/terms-of-service' target='_blank'>
              Terms of service
            </a>
          </div>
          <div>
            <a href='https://tipwander.com/privacy-policy' target='_blank'>
              Privacy
            </a>
          </div>
        </div>
      </ReactModalComponent>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/InfoModal.tsx